module.exports = __webpack_public_path__ + "static/media/user-management.638473c6.svg";